import { render, staticRenderFns } from "./VerifyHistory.vue?vue&type=template&id=f5dcc002&scoped=true&"
import script from "./VerifyHistory.vue?vue&type=script&lang=js&"
export * from "./VerifyHistory.vue?vue&type=script&lang=js&"
import style0 from "./VerifyHistory.vue?vue&type=style&index=0&id=f5dcc002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dcc002",
  null
  
)

export default component.exports